module.exports = __webpack_public_path__ + "static/media/glyph-harmony.48e7d184.svg";